import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '../context/ThemeContext';

// Toggles dark mode directly without opening a secondary settings dialog.
export default function DarkModeToggle() {
  const { t } = useTranslation();
  const { dark, toggleDarkMode } = useThemeContext();
  const actionLabel = t(dark ? 'theme.useLightMode' : 'theme.useDarkMode');

  return (
    <button
      type={'button'}
      className={`theme-toggle ${dark ? 'theme-toggle--on' : ''}`}
      onClick={toggleDarkMode}
      role={'switch'}
      aria-checked={dark}
      aria-label={t('theme.darkMode')}
      title={actionLabel}
    >
      <DarkModeOutlinedIcon className={'theme-toggle__icon'} aria-hidden={true} />
      <span className={'theme-toggle__track'} aria-hidden={true}>
        <span className={'theme-toggle__thumb'} />
      </span>
    </button>
  );
}
